import register from './register'
import common from './common';
import myPage from "./myPage";
import bookingOrder from './booking_order'
import homePage from './home_page'
import changeEndUserInfo from './change_end_user_info'
import bookingConfirm from  './booking_confirm'
import changEmail from './change_email'
import login from './login';
import rulesAtMyPage from './rules_at_my_page'
import resetPassword from './reset_password.json'

const jpMessage = {
    ...register,
    ...common,
    ...bookingOrder,
    ...myPage,
    ...bookingConfirm,
    ...changeEndUserInfo,
    ...changEmail,
    ...homePage,
    ...login,
    ...rulesAtMyPage,
    ...resetPassword,
};

export default jpMessage;
